import React, { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import Sidebar from "../../components/Admin/Sidebar";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

const GstCatalogue = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const [gst, setGst] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedGst, setSelectedGst] = useState(null); // Store selected GST data for editing
  const [newGst, setNewGst] = useState({
    hsncode: "",
    sgst: "",
    cgst: "",
    igst: "",
  }); // State for adding new GST
  const [showDelete, setShowDelete] = useState(false);
  const [selectedDeleteGst, setSelectedDeleteGst] = useState(null);

  useEffect(() => {
    fetchGstData();
  }, []);
  //   const decimalNumberRegex = /^[0-9]+(\.[0-9]+)?$/;

  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const fetchGstData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/getallgstdata`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const fetchedData = response.data.gst; // Access the 'gst' property from the response
      setGst(fetchedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditClick = (item) => {
    setSelectedGst(item); // Set selected GST for editing
    setShowEditModal(true); // Show edit modal
  };

  const handleAddClick = () => {
    setShowAddModal(true); // Show add modal
  };

  const handleModalClose = () => {
    setShowEditModal(false);
    setSelectedGst(null); // Reset selected GST
    setShowAddModal(false);
  };

  const handleAddGst = async () => {

    if (newGst.hsncode === "") {
      toast.error("Please enter  HSN code!");
      return;
    }

    const numberRegex = /^\d+(\.\d{1,2})?$/;

    if (newGst.sgst === "" || !numberRegex.test(newGst.sgst)) {
      toast.error("Please enter a valid SGST (numbers only)!");
      return;
    }

    if (newGst.cgst === "" || !numberRegex.test(newGst.cgst)) {
      toast.error("Please enter a valid CGST (numbers only)!");
      return;
    }

    if (newGst.igst === "" || !numberRegex.test(newGst.igst)) {
      toast.error("Please enter a valid IGST (numbers only)!");
      return;
    }

    const hsnCodeRegex = /^[A-Za-z0-9]{4,8}$/;
    if (!hsnCodeRegex.test(newGst.hsncode)) {
      toast.error(
        "HSN code must be exactly 4 or 8 characters and can only contain letters and numbers!"
      );
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}product/creategst`,
        newGst,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "error") {
        toast.error(response.data.message);
      } else {
        toast.success(response.data.message);
        fetchGstData(); // Refresh GST data
        setShowAddModal(false); // Close modal
        setNewGst({ hsncode: "", sgst: "", cgst: "", igst: "" }); // Reset form
      }
    } catch (error) {
      console.error("Error adding GST:", error);
    }
  };

  const handleSaveChanges = async () => {
    if (selectedGst.hsncode === "") {
      toast.error("Please enter  HSN code!");
      return;
    }
    const numberRegex = /^\d+(\.\d{1,2})?$/;
    if (selectedGst.sgst === "" || !numberRegex.test(selectedGst.sgst)) {
      toast.error("Please enter a valid SGST (numbers only)!");
      return;
    }

    if (selectedGst.cgst === "" || !numberRegex.test(selectedGst.cgst)) {
      toast.error("Please enter a valid CGST (numbers only)!");
      return;
    }

    if (selectedGst.igst === "" || !numberRegex.test(selectedGst.igst)) {
      toast.error("Please enter a valid IGST (numbers only)!");
      return;
    }

    const hsnCodeRegex = /^[A-Za-z0-9]{4,8}$/;
    if (!hsnCodeRegex.test(selectedGst.hsncode)) {
      toast.error(
        "HSN code must be exactly 4 or 8 characters and can only contain letters and numbers!"
      );
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}product/updategst`,
        selectedGst, // Send the updated GST data
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === "error") {
        toast.error(response.data.message);
      } else {
        toast.success(response.data.message);

        fetchGstData(); // Refresh GST data
        setShowEditModal(false); // Close edit modal
        setSelectedGst(null); // Reset selected GST
      }
    } catch (error) {
      console.error("Error updating GST:", error);
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteGst(item); // Set selected GST for deletion
    setShowDelete(true); // Show delete modal
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setSelectedDeleteGst(null); // Reset the selected GST
  };

  const handleDeleteSubmit = async () => {
    try {
      if (!selectedDeleteGst) return;

      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}product/deletegst/${selectedDeleteGst.id}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "error") {
        toast.error(response.data.message);
      } else {
        toast.error(response.data.message);
        fetchGstData(); // Refresh GST data
        handleDeleteClose(); // Close modal
      }
    } catch (error) {
      console.error("Error deleting GST:", error);
    }
  };

  return (
    <div className="container-fluid">

      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div className="mb-4">
                <h5>GST Catalogue</h5>
                <h6 className="text-muted">View & manage GSTs</h6>
              </div>
              <Button
                className="btn btn-primary btn-sm p-2 mb-3"
                onClick={handleAddClick}
              >
                Add GST <Icon.PlusCircle className="ms-2" />
              </Button>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th className="text-nowrap">HSN Code</th>
                    <th>SGST</th>
                    <th>CGST</th>
                    <th>IGST</th>
                    <th className="text-nowrap">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {gst.length > 0 ? (
                    gst.map((item) => (
                      <tr key={item.id}>
                        <td>{item.hsncode}</td>
                        <td>{item.sgst}%</td>
                        <td>{item.cgst}%</td>
                        <td>{item.igst}%</td>
                        <td className="text-nowrap">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(item)}
                          >
                            <Icon.Pencil />
                          </button>{" "}
                          &nbsp;
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(item)}
                          >
                            <Icon.Trash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Add GST Modal */}
      <Modal
        show={showAddModal}
        onHide={handleModalClose}
        style={{ marginTop: "20vh" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add GST</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <label>HSN Code</label>
              <input
                type="text"
                className="form-control"
                value={newGst.hsncode}
                onChange={(e) =>
                  setNewGst({ ...newGst, hsncode: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>SGST</label>
              <input
                type="text"
                className="form-control"
                value={newGst.sgst}
                onChange={(e) => {
                  const sgst = e.target.value;
                  const cgst = newGst.cgst || 0;
                  const igst = parseFloat(sgst || 0) + parseFloat(cgst || 0);
                  setNewGst({ ...newGst, sgst, igst: igst.toFixed(2) });
                }}
              />
            </div>
            <div className="form-group">
              <label>CGST</label>
              <input
                type="text"
                className="form-control"
                value={newGst.cgst}
                onChange={(e) => {
                  const cgst = e.target.value;
                  const sgst = newGst.sgst || 0;
                  const igst = parseFloat(cgst || 0) + parseFloat(sgst || 0);
                  setNewGst({ ...newGst, cgst, igst: igst.toFixed(2) });
                }}
              />
            </div>
            <div className="form-group">
              <label>IGST</label>
              <input
                type="text"
                className="form-control"
                value={newGst.igst}
                onChange={(e) => setNewGst({ ...newGst, igst: e.target.value })}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddGst}>
            Add GST
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit GST Modal */}
      {selectedGst && (
        <Modal
          show={showEditModal}
          onHide={handleModalClose}
          style={{ marginTop: "20vh" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit GST</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="form-group">
                <label>HSN Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedGst.hsncode}
                  onChange={(e) =>
                    setSelectedGst({ ...selectedGst, hsncode: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <label>SGST</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedGst.sgst}
                  onChange={(e) =>
                    setSelectedGst({ ...selectedGst, sgst: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <label>CGST</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedGst.cgst}
                  onChange={(e) =>
                    setSelectedGst({ ...selectedGst, cgst: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <label>IGST</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedGst.igst}
                  onChange={(e) =>
                    setSelectedGst({ ...selectedGst, igst: e.target.value })
                  }
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveChanges}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Delete GST Modal */}
      <Modal show={showDelete} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Icon.Trash3 color="black" size={40} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container p-3 text-center">
            <h5>Are you sure you want to delete this GST record?</h5>
            <p>
              <strong>HSN Code:</strong> {selectedDeleteGst?.hsncode}
            </p>
            <button
              onClick={handleDeleteSubmit}
              className="btn btn-danger mt-3"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer theme="dark" autoClose={2000} />
    </div>
  );
};

export default GstCatalogue;
